<template>
  <nav aria-label="Secondary menu">
    <ul class="menu-secondary">
      <CollaborationAdvertizer />
      <li class="offline" :class="{ expanded: isMenuExpanded }" v-if="!online">
        <OfflineIcon
          v-tippy="{
            hideOnClick: false,
            arrow: false,
            animation: 'fade',
            duration: 200,
            delay: [700, 0],
            placement: offlineTooltipPlacement,
            content: 'Offline',
          }"
        />
      </li>
      <li class="collapse-item">
        <MenuItem :route="collapseItem" @click="$emit('toggleMenuExpand')" />
      </li>
      <SubMenuAccount />
    </ul>
  </nav>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";

import OfflineIcon from "@/components/icons/OfflineIcon.vue";
import * as inject from "@/components/inject";
import CollaborationAdvertizer from "@/components/menu/CollaborationAdvertizer.vue";
import { createUiMenuItem, UI_MENU_ITEMS } from "@/components/menu/menuItems";
import { useReleaser } from "@/ref";
import { placementForDir } from "@/utils/direction";

import MenuItem from "./MenuItem.vue";
import SubMenuAccount from "./SubMenuAccount.vue";

export default defineComponent({
  components: {
    CollaborationAdvertizer,
    OfflineIcon,
    MenuItem,
    SubMenuAccount,
  },
  emits: {
    toggleMenuExpand: () => true,
  },
  async setup() {
    const controller = inject.controller();
    const isMenuExpanded = inject.menu().isExpanded;
    const direction = inject.direction();
    const releaser = useReleaser();
    const offlineTooltipPlacement = computed(() =>
      placementForDir("right", direction.value)
    );
    const online = await releaser.add(controller.online());

    const collapseItem = createUiMenuItem(UI_MENU_ITEMS.Collapse);

    return {
      isMenuExpanded,
      online,
      collapseItem,
      offlineTooltipPlacement,
    };
  },
});
</script>
<style scoped lang="scss">
nav {
  padding-bottom: 8px;

  li.offline {
    cursor: default;
    margin: 4px 0;
    padding: 6px 0;
    display: flex;
    justify-content: center;
    outline: none;
    align-items: center;
    svg {
      :deep(.stroke) {
        @include transition(stroke $transition_menu);
        @include themed() {
          stroke: t($grey-30);
        }
      }
      :deep(.fill) {
        @include transition(fill $transition_menu);
        @include themed() {
          fill: t($grey-30);
        }
      }
    }
    &:not(.expanded) svg {
      padding: 6px;
      height: 20px;
    }
    &.expanded {
      margin: 1px 5px;
      padding: 7px;
      justify-content: flex-start;
      svg {
        width: 18px;
        height: 18px;
      }
    }
  }

  .collapse-item {
    opacity: 0;
    transition: opacity 150ms ease;
  }

  &:hover .collapse-item {
    opacity: 1;
  }
}
</style>
